import { turfBounds } from 'shared/utils';
import { reduceAsync } from 'common/utils';

import { Station } from '../types';

type Coordinates = [
  Station['coordinates']['longitude'],
  Station['coordinates']['latitude']
];

export const getStationsFitBounds = async (stations: Station[]) => {
  const stationCoordinates = await reduceAsync<Station, Coordinates>(
    stations,
    (acc, station) => {
      acc.push([
        station.coordinates.longitude,
        station.coordinates.latitude
      ]);

      return acc;
    },
    [] as Coordinates[]
  );

  // @ts-ignore
  return turfBounds(stationCoordinates);
};
